/**
 * PricingPage — `/pricing` (s216, SEO phase 1 item 2).
 *
 * Renders the EXISTING pricing section as a page, from the shared `PricingSection`. "People search
 * 'X pricing'" and partners need a URL to send; before this, pricing was a scroll anchor whose URL
 * stayed `/`, so there was nothing to link to or rank.
 *
 * 🔴 It renders the SAME component the landing page renders — not a copy. A second set of prices
 * that could drift from the first is worse than no page at all.
 */
import { useLocation } from 'wouter';
import { PublicLayout } from '@/components/public/PublicLayout';
import { PricingSection } from '@/components/public/PricingSection';
import { Seo } from '@/components/public/Seo';
import { OrganizationStructuredData } from '@/components/public/StructuredData';
import { useAuth } from '@/contexts/AuthContext';

export default function PricingPage() {
  const [, navigate] = useLocation();
  const { isAuthenticated } = useAuth();

  return (
    <PublicLayout>
      <Seo path="/pricing" />
      <OrganizationStructuredData />
      {/* `heading="h1"` so the page has exactly one <h1>; the landing page's copy renders an <h2>. */}
      <PricingSection heading="h1" onStart={() => navigate(isAuthenticated ? '/dashboard' : '/signup')} />
    </PublicLayout>
  );
}
